import { useEffect, useState, useMemo } from "react";
import { BiPlusCircle, BiMinusCircle } from "react-icons/bi";
import { RxCrossCircled } from "react-icons/rx";
import { getVariable } from "../Helpers/Session";

const ListItem = ({
  cartQuantity = 1,
  checkedItem = false,
  pkid,
  product_image,
  unitMasterName,
  page,
  itemTitle,
  selectedItem,
  removeItem,
  updateQty,
  fUnitRate,
}) => {
  const curSymbol = getVariable("curSymbol", true);
  const cartItems = getVariable("cartItems", true) || [];

  // Find the matching cart item by pkid
  const cartItem = useMemo(
    () => cartItems.find((item) => item.pkid == pkid.toString()),
    [cartItems, pkid]
  );

  const [checked, setChecked] = useState(checkedItem);
  const itemInQty = cartItem ? cartItem.cartQuantity : cartQuantity;

  useEffect(() => {
    setChecked(checkedItem);
  }, [checkedItem]);

  const handleCheck = (e) => {
    e.stopPropagation();
    if (selectedItem) selectedItem(!checked, pkid);
  };

  return (
    <li className="list-item" onClick={handleCheck}>
      <div className="prod-img">
        <img src={product_image} alt={itemTitle} className="product_image" />
      </div>
      <div className="about-prod">
        <div className="prod-name-unit">
          <h4>{itemTitle}</h4>
          {unitMasterName && (
            <div className="extra-info">Rate in {unitMasterName}</div>
          )}
        </div>
      </div>
      <div className="prod-price text-right">
        {page === "itemlist" || page === "returnitemlist" ? (
          <div className="action-cnt">
            <label className="custom-checkbox">
              <input
                type="checkbox"
                checked={checked}
                onChange={handleCheck}
                id={"checkbox_" + pkid}
              />
              <span className="checkbox-cnt"></span>
            </label>
          </div>
        ) : (
          <RxCrossCircled
            className="cursor-pointer text-2xl float-right"
            onClick={() => removeItem(pkid)}
          />
        )}

        {(page === "placeorder" || page === "returnorder") && (
          <div className="prod-qty">
            <BiMinusCircle
              className="cursor-pointer text-2xl"
              onClick={() => updateQty(pkid, Math.max(1, itemInQty - 1))}
            />
            <input
              type="text"
              className="input_qty_box p-2 border rounded"
              value={itemInQty}
              onChange={(e) => {
                const newQty = Math.max(1, parseInt(e.target.value) || 1);
                updateQty(pkid, newQty);
              }}
            />
            <BiPlusCircle
              className="cursor-pointer text-2xl"
              onClick={() => updateQty(pkid, itemInQty + 1)}
            />
          </div>
        )}

        <div className="price">
          {page === "itemlist" && checked && (
            <div
              className="quantity"
              style={{ fontWeight: "normal", fontSize: "small" }}
            >
              Qty: {itemInQty}
            </div>
          )}
          {curSymbol} {cartItem ? cartItem.fUnitRate : fUnitRate}
        </div>
      </div>
    </li>
  );
};

export default ListItem;
